import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Module } from "types/generated";
import { AccessResult, hasAdminAccess } from "utils/access";

export const MODULE_ADMIN_ACCESS_MESSAGE =
  "You don't have permission to perform this action. Modules can only be edited in the account or space where they were created";

const useHasModuleAdminAccess = (): ((module?: Module) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (module?: Module) => {
      if (!module) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const result = hasAdminAccess(viewer, module.spaceDetails?.id || module.space);

      if (result) {
        return { result: true };
      }

      return { result: false, message: MODULE_ADMIN_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useHasModuleAdminAccess;
